<div class="flex flex-col">
    <ng-content></ng-content>
</div>
